import { call, put } from 'redux-saga/effects'
import { RequestMethods } from 'utils/axios/methods'
import type { PayloadAction } from '@reduxjs/toolkit'
import { Actions_PageLoader } from 'redux/modules/pageloader/Actions'
import { sagaAction_Error } from 'redux/sagas/actions/SagaAction_Error'
import { Actions_Bookings } from 'redux/modules/bookings/Actions'
import { TCurrentBooking } from 'utils/types/TCurrentBooking'
import { TStoreTemplate } from 'redux/config/root-types'
import { Actions_Notifications } from 'redux/modules/notification/Actions'

const { post, get } = RequestMethods()

export interface ISagaWorker_CancelBooking {
  id: number
  percent: number
  onSuccess: () => void
}

export default function* SagaWorker_CancelBooking(action: PayloadAction<ISagaWorker_CancelBooking>) {
  const { id } = action.payload
  try {
    yield put(Actions_PageLoader.store.showLoader())

    //------------------------- Getting and saving station ---------------------------//

    const data = { refundPercent: action.payload.percent }
    yield call(async () => await post<TCurrentBooking>(`/bookings/${id}/cancel`, data))

    const resBooking: TStoreTemplate<TCurrentBooking> = yield call(
      async () => await get<TCurrentBooking>(`/bookings/${id}/extended`),
    )
    yield put(Actions_Bookings.store.setCurrentBooking(resBooking.data))

    action.payload.onSuccess()

    yield put(
      Actions_Notifications.store.setNotification({ message: 'Booking successfully canceled', type: 'Success' }),
    )

    yield put(Actions_PageLoader.store.hideLoader())
  } catch (e) {
    yield call(() => sagaAction_Error(e))
  } finally {
    yield put(Actions_PageLoader.store.hideLoader())
  }
}
